import api from '@/api'
import logger from '@/logger'
import objects from '@/objects'
import store from '@/store'
import D2C_Entity from './Entity'

class D2C_Key extends D2C_Entity {
  target = 'key'
  icon = 'key'
  static objectType = 'entityType'
  static typeName = 'key'
  static active = true
  static fields = {
    ...D2C_Entity.fields,
    name: {
      default: '',
      label: 'Name',
      path: 'name',
      required: true,
      width: 6,
      validate(value, entity) {
        if (!entity.created && store.getters.keysByName[value]) {
          return 'This name is already used'
        }
        return (value && value.length > 0) ? null : 'Must be filled'
      },
      creating: {},
    },
    type: {
      default: '',
      label: 'Type',
      path: 'type',
      required: true,
      width: 5,
      validate() {
        return null
      },
      creating: {},
    },
    default: {
      default: false,
      label: 'Default',
      path: 'default',
      required: true,
      width: 5,
      validate() {
        return null
      },
      creating: {},
    },
    key: {
      default: '',
      label: 'Key',
      path: 'key',
      placeholder: 'Typically starts with "ssh-ed25519 …" or "ssh-rsa …"',
      required: true,
      validate(value, entity) {
        if (!entity.created && store.getters.keys.find(item => item.key === value)) {
          return 'This key is already added'
        }
        return (value.length > 0) ? null : 'Must be filled'
      },
      creating: {},
    },
  }
  static create(props) {
    const Constructor = objects._keysByType[props.type]
    if (Constructor) {
      return new Constructor(props)
    }
    logger.warning(`🚨 Unknown key type: ${props.type}`)
    return new D2C_Key(props)
  }
  get _hosts() {
    return store.getters.hosts.filter(host => host.keys.includes(this.id))
  }
  create() {
    return api.createKey(this._values)
  }
  destroy() {
    return api.destroyKey(this.id)
  }
}

export default D2C_Key
